import React, { useState, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Divider,
} from "@mui/material";
import { Close, ArrowBack } from "@mui/icons-material";
import PhoneAuthFlow from "./PhoneAuthFlow";
import QrLoginDrawerBlock from "./QrLoginDrawerBlock";
import logoIcon from "assets/images/logos/logo-icon.png";

/**
 * PhoneAuthDialog - Reusable modal wrapper for phone authentication
 *
 * Use this component anywhere you need a phone auth modal.
 * It handles the dialog chrome (title bar, close button) and delegates
 * the actual auth flow to PhoneAuthFlow.
 */
const PhoneAuthDialog = ({ open, onClose, onSuccess }) => {
  const [step, setStep] = useState(0);
  const backHandlerRef = useRef(null);

  const handleBackClick = () => {
    backHandlerRef.current?.();
  };

  // After step 0, prevent accidental dismissal - user must use explicit close button
  const canDismiss = step === 0;

  return (
    <Dialog
      open={open}
      onClose={canDismiss ? onClose : undefined}
      disableEscapeKeyDown={!canDismiss}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Back button - left side */}
        <IconButton
          aria-label="back"
          onClick={handleBackClick}
          sx={{
            position: "absolute",
            left: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            visibility: step === 0 ? "hidden" : "visible",
          }}
        >
          <ArrowBack />
        </IconButton>

        {/* Logo - center */}
        <Box
          component="img"
          src={logoIcon}
          alt="HealthDesk"
          sx={{ height: 32 }}
        />

        {/* Close button - right side */}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ py: 3 }}>
        <PhoneAuthFlow
          onClose={onClose}
          onSuccess={onSuccess}
          onStepChange={setStep}
          backHandlerRef={backHandlerRef}
          inDialog
        />
        <Divider sx={{ my: 3 }} />
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <QrLoginDrawerBlock />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PhoneAuthDialog;
